<template>
  <v-dialog :value="dialog" :max-width="1000" @input="$emit('update:dialog')" scrollable>
    <v-card class="orders" max-width="1000px" v-if="!loading">
      <v-card-title class="py-0 justify-center">
        <span class="secondary--text font-bold pt-2">
          {{ $t("order_details") }}</span>
      </v-card-title>
      <v-card-subtitle class="mt-1">
        <h3 class="text-center primary--text">
          <span v-if="
            airport_service_order.arrival_at &&
            airport_service_order.departure_at
          ">
            {{ $t("go_and_back") }}
          </span>
          <span v-else-if="airport_service_order.arrival_at">
            {{ $t("on_way") }}
          </span>
          <span v-else-if="airport_service_order.departure_at">
            {{ $t("back_only") }}
          </span>
        </h3>
      </v-card-subtitle>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" lg="8">
              <v-row>
                <v-col cols="12" lg="3">
                  <v-chip class="error orders__title">
                    <span class="white--text font-bold">
                      {{ $t("invoice_and_detials") }}
                    </span>
                  </v-chip>
                </v-col>
                <v-col cols="12">
                  <v-card flat class="orders__invoice">
                    <v-container>
                      <v-row>
                        <template v-if="airport_service_order.created_at">
                          <v-col cols="12" lg="6" class="align-self-center">
                            <span class="secondary--text size-16 weight-800">
                              {{ $t("table.service_request_date") }}
                            </span>
                          </v-col>
                          <v-col cols="12" lg="6" class="align-self-center">
                            <span class="secondary--text size-16 weight-800">
                              {{
                                convertDateAndTime(airport_service_order.created_at)
                              }}
                            </span>
                          </v-col>
                        </template>
                        <template v-if="airport_service_order.arrival_at">
                          <v-col cols="12" lg="6" class="align-self-center">
                            <div class="my-2">
                              <span class="secondary--text size-16 weight-800">
                                {{ $t("fields.arrival_at") }}
                              </span>
                            </div>
                          </v-col>
                          <v-col cols="12" lg="6" class="align-self-center">
                            <span class="secondary--text size-16 weight-800">
                              {{
                                convertDateAndTime(airport_service_order.arrival_at)
                              }}
                            </span>
                          </v-col>
                        </template>

                        <template v-if="airport_service_order.departure_at">
                          <v-col cols="12" lg="6" class="align-self-center">
                            <span class="secondary--text size-16 weight-800">
                              {{ $t("fields.departure_at") }}
                            </span>
                          </v-col>
                          <v-col cols="12" lg="6" class="align-self-center">
                            <span class="secondary--text size-16 weight-800">
                              {{
                                convertDateAndTime(airport_service_order.departure_at)
                              }}
                            </span>
                          </v-col>
                        </template>

                        <v-col cols="12" lg="6" class="align-self-center">
                          <span class="secondary--text size-16 weight-800">
                            {{ $t("fields.flight_number") }}
                          </span>
                        </v-col>
                        <v-col cols="12" lg="6" class="align-self-center">
                          <div class="my-2">
                            <span class="secondary--text size-16 weight-800">
                              {{ airport_service_order.flight_number }}
                            </span>
                          </div>
                        </v-col>

                        <v-col cols="12" lg="6" class="align-self-center d-flex">
                          <span class="secondary--text size-16 weight-800">
                            {{ $t("fields.airline") }}
                          </span>
                        </v-col>
                        <v-col cols="12" lg="6" class="align-self-center">
                          <div class="my-2">
                            <span class="secondary--text size-16 weight-800">
                              {{
                                airport_service_order.airline &&
                                airport_service_order.airline.name
                              }}
                            </span>
                          </div>
                        </v-col>
                        <v-col cols="12" lg="6" class="align-self-center">
                          <span class="secondary--text size-16 weight-800">
                            {{ $t("fields.persons_count") }}
                          </span>
                        </v-col>
                        <v-col cols="12" lg="6" class="align-self-center">
                          <div>
                            <span class="secondary--text size-16 weight-800">
                              {{ airport_service_order.persons_count }}
                              {{ $t("persons") }}
                            </span>
                          </div>
                        </v-col>
                        <v-col cols="12" lg="6" class="align-self-center" v-if="airport_service_order.need_visa">
                          <span class="secondary--text size-16 weight-800">
                            {{ $t("fields.return_visa") }}
                          </span>
                          <div>
                            <small class="secondary--text">
                              (
                              <span> {{ $t("on_way_price") }}</span>
                              <span>
                                {{
                                  airport_service_order.arrival_visa_service_person_price
                                  | transformCurrency
                                }}
                              </span>
                              -
                              <span> {{ $t("return_per_price") }}</span>
                              <span>
                                {{
                                  airport_service_order.departure_visa_service_person_price
                                  | transformCurrency
                                }}
                              </span>
                              )
                            </small>
                          </div>
                        </v-col>
                        <v-col cols="12" lg="6" class="align-self-center" v-if="airport_service_order.need_visa">
                          <div>
                            <span class="primary--text size-16 font-bold">
                              {{
                                (airport_service_order.arrival_visa_service_person_price +
                                  airport_service_order.departure_visa_service_person_price)
                                | transformCurrency
                              }}
                            </span>
                          </div>
                        </v-col>
                        <v-col cols="12" lg="6" class="align-self-center" v-if="airport_service_order.need_procedures">
                          <span class="secondary--text size-16 weight-800">
                            {{ $t("fields.clearance_paper") }}
                          </span>
                          <div>
                            <small class="secondary--text">
                              (
                              <span> {{ $t("on_way_price") }}</span>
                              <span>
                                {{
                                  airport_service_order.arrival_procedures_service_price
                                  | transformCurrency
                                }}
                              </span>
                              -
                              <span> {{ $t("return_per_price") }}</span>
                              <span>
                                {{
                                  airport_service_order.departure_procedures_service_price
                                  | transformCurrency
                                }}
                              </span>
                              )
                            </small>
                          </div>
                        </v-col>
                        <v-col cols="12" lg="6" class="align-self-center" v-if="airport_service_order.need_procedures">
                          <div>
                            <span class="primary--text size-16 font-bold">
                              {{
                                (airport_service_order.arrival_procedures_service_price +
                                  airport_service_order.departure_procedures_service_price)
                                | transformCurrency
                              }}
                            </span>
                          </div>
                        </v-col>
                        <v-col cols="12" lg="6" class="align-self-center" v-if="airport_service_order.need_transport">
                          <span class="secondary--text size-16 weight-800">
                            {{ $t("fields.transporter_go_and_back") }}
                          </span>
                          <div>
                            <small class="secondary--text">
                              (
                              <span> {{ $t("on_way_price") }}</span>
                              <span>
                                {{
                                  airport_service_order.arrival_transport_service_person_price
                                  | transformCurrency
                                }}
                              </span>
                              -
                              <span> {{ $t("return_per_price") }}</span>
                              <span>
                                {{
                                  airport_service_order.departure_transport_service_person_price
                                  | transformCurrency
                                }}
                              </span>
                              )
                            </small>
                          </div>
                        </v-col>
                        <v-col cols="12" lg="6" class="align-self-center" v-if="airport_service_order.need_transport">
                          <div>
                            <span class="primary--text size-16 font-bold">
                              {{
                                (airport_service_order.arrival_transport_service_person_price +
                                  airport_service_order.departure_transport_service_person_price)
                                | transformCurrency
                              }}
                            </span>
                          </div>
                        </v-col>
                      </v-row>
                    </v-container>
                    <v-card-actions class="px-0 mx-0 d-flex flex-wrap">
                      <v-col cols="12" lg="6" class="align-self-center">
                        <span class="error--text size-16 weight-800">
                          {{ $t("table.total_price") }}
                        </span>
                      </v-col>
                      <v-col cols="12" lg="6" class="align-self-center py-0">
                        <v-list flat class="transparent pa-0 mx-0">
                          <v-list-item class="px-0">
                            <v-list-item-content>
                              <v-list-item-title>
                                <span class="error--text size-16 weight-800">
                                  {{
                                    airport_service_order.grand_total
                                    | transformCurrency
                                  }}
                                </span>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-col>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>

              <!-- order details -->
              <v-row>
                <v-col cols="12" v-if="
                  airport_service_order &&
                  airport_service_order.passport_images.length > 0
                ">
                  <v-card flat class="orders__invoice">
                    <v-container>
                      <v-row>
                        <v-col cols="12">
                          <h3 class="secondary--text font-bold">
                            {{ $t("passport_copies") }}
                          </h3>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-card class="orders__media-card" v-if="dialog">
                            <MediaSlider :items="airport_service_order.passport_images" />
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                </v-col>
              </v-row>
              <user-details
                :userDetails="airport_service_order.user"
                v-if="Object.keys(airport_service_order.user).length"
              />
            </v-col>
            <v-col cols="12" lg="4">
              <v-row>
                <v-col cols="12" lg="3">
                  <v-chip class="error orders__title">
                    <span class="white--text font-bold">
                      {{ $t("order_status") }}
                    </span>
                  </v-chip>
                </v-col>
              </v-row>
              <v-row style="height: 97%">
                <v-col cols="12" class="d-flex flex-column">
                  <v-row>
                    <v-col cols="12">
                      <OrderStatus :item="airport_service_order" />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" class="align-self-end">
                      <v-row>
                        <v-col cols="12">
                          <v-btn depressed block large class="primary" :disabled="airport_service_order.accepted"
                            @click="handleAcceptOrder">
                            <span class="white--text font-bold">
                              {{ $t("accept") }}
                            </span>
                          </v-btn>

                          <!-- <template v-if="airport_service_order.can_cancel">
                            <v-btn
                              outlined
                              @click="handleCancel"
                              depressed
                              block
                              large
                              color="red"
                              class="mt-2"
                            >
                              <span class="red--text font-bold">
                                {{ $t("cancel_order") }}
                              </span>
                            </v-btn>
                          </template> -->
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
    <v-card min-height="200px" max-width="1000px" v-else>
      <loader class="h-100" />
    </v-card>
  </v-dialog>
</template>

<script>
import { IndexData, StoreData } from "@/helpers/apiMethods";
export default {
  name: "TripsOrder",
  components: {
    OrderStatus: () => import("./Status.vue"),
    UserDetails: () => import("../sharedCmp/userDetails.vue")
  },
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      airport_service_order: {},
      loading: true
    };
  },
  methods: {
    handleAcceptOrder() {
      const formData = new FormData();
      formData.append("_method", "put");
      formData.append("accept", 1);
      this.popUp().then(value => {
        if (!value.dismiss) {
          StoreData({
            reqName: `airport-service-orders/${this.airport_service_order.reference_number}`,
            data: formData
          })
            .then(() => {
              this.$emit("update:dialog");
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    handleCancel() {
      const formData = new FormData();
      formData.append("_method", "delete");
      this.popUp().then(value => {
        if (!value.dismiss) {
          StoreData({
            reqName: `airport-service-orders/${this.airport_service_order.reference_number}`,
            data: formData
          })
            .then(() => {
              this.$emit("update:dialog");
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    handleShow() {
      IndexData({
        reqName: `airport-service-orders/${this.item.reference_number}`
      })
        .then(res => {
          const { airport_service_order } = res.data;
          this.airport_service_order = airport_service_order;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  watch: {
    dialog: {
      handler(value) {
        if (value) {
          this.handleShow();
        } else {
          this.loading = true;
          this.$emit("refresh-table");
        }
      },
      immediate: false
    }
  }
};
</script>
